export default __webpack_public_path__ + "static/media/SupervisorSafetWalk.cfd94518.png";